(() => {
  if (customElements.get('article-gallery-slider')) {
    return;
  }

  class ArticleGallerySlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.pswp = null;
      this.galleryItems = [];
      this.PhotoSwipe = null;
    }

    connectedCallback() {
      this.initSlider();
      this.initPhotoSwipe();
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      this.options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 500,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      };

      this.slider = new Swiper(sliderElement, this.options);
    }

    async initPhotoSwipe() {
      // Wait for PhotoSwipe module to be available
      // Try to get it from window or import dynamically
      if (!this.PhotoSwipe) {
        // Check if PhotoSwipe is available globally (if loaded as module)
        if (window.PhotoSwipe) {
          this.PhotoSwipe = window.PhotoSwipe;
        } else {
          // Try dynamic import
          try {
            // Get the script src from the module script tag
            const photoSwipeScript = document.querySelector('script[src*="photoswipe.esm.min.js"]');
            if (photoSwipeScript) {
              const scriptSrc = photoSwipeScript.getAttribute('src');
              const module = await import(scriptSrc);
              this.PhotoSwipe = module.default || module;
            } else {
              // Fallback: try relative import
              const module = await import('./photoswipe.esm.min.js');
              this.PhotoSwipe = module.default || module;
            }
          } catch (error) {
            console.error('Failed to load PhotoSwipe:', error);
            // Retry after a short delay
            setTimeout(() => this.initPhotoSwipe(), 200);
            return;
          }
        }
      }

      // Collect all gallery items from expand buttons
      const expandButtons = this.querySelectorAll('.article-gallery-slider__expand-btn');
      if (expandButtons.length === 0) return;

      this.galleryItems = Array.from(expandButtons).map((button) => ({
        src: button.getAttribute('data-pswp-src'),
        width: parseInt(button.getAttribute('data-pswp-width'), 10) || 0,
        height: parseInt(button.getAttribute('data-pswp-height'), 10) || 0,
      }));

      // Add click handlers to all expand buttons
      expandButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openPhotoSwipe(index);
        });
      });
    }

    async openPhotoSwipe(index) {
      if (this.galleryItems.length === 0) return;

      // Ensure PhotoSwipe is loaded
      if (!this.PhotoSwipe) {
        await this.initPhotoSwipe();
        if (!this.PhotoSwipe) return;
      }

      const options = {
        dataSource: this.galleryItems,
        index: index,
        showHideAnimationType: 'zoom',
        zoomAnimationDuration: 400,
        bgOpacity: 0.9,
        spacing: 0.12,
        easing: 'cubic-bezier(0.4, 0, 0.22, 1)',
      };

      this.pswp = new this.PhotoSwipe(options);
      this.pswp.init();
    }
  }

  customElements.define('article-gallery-slider', ArticleGallerySlider);
})();

